import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const UserCardWrapStyled = styled(FlexContainer)`
  cursor: pointer;
`;

export const UserNameStyled = styled(Typography)`
  margin-left: 1rem;
`;
